import { SearchControllerParams } from "../../../features/search/types"
import { jsonClone } from "../../../utils/json"
import {
  CheckboxFilterOption,
  FilterCategory,
  RangeFilterOption,
} from "../components/filters/types"
import { AvailabilitySearchFilters } from "../types"
import { expandTreeOptions } from "./filters"
import { convertToFilterTags } from "./tags"

const getPriceFilter = (items: FilterCategory[]) =>
  items.find((x) => x.id === "price")

const getMinPriceFilter = (currentValue?: number) => {
  return currentValue && currentValue > 0 ? currentValue : undefined
}

const getMaxPriceFilter = (currentValue?: number, maxValue?: number) => {
  if (!currentValue || !maxValue) {
    return undefined
  }

  return currentValue < maxValue ? currentValue : undefined
}

const getPriceFilters = (items: FilterCategory[]) => {
  const option = getPriceFilter(items)?.options[0] as RangeFilterOption
  return {
    minPrice: getMinPriceFilter(option.values[0]),
    maxPrice: getMaxPriceFilter(option.values[1], option.max),
  }
}

const getDiscountFilters = (items: FilterCategory[]) => {
  const filter = items.find((x) => x.type === "percent")
  return {
    discountPercentValues: (filter?.options as CheckboxFilterOption[])
      ?.filter((x: any) => (x as CheckboxFilterOption).selected)
      .map((x) => parseFloat(x.value))
      .filter((x) => x),
  }
}

const getBrandFilters = (
  searchParams: SearchControllerParams,
  items: FilterCategory[]
) => {
  const brandsFilter = items.find((x) => x.key === "brand")

  // filtro implicito in pagina brand
  if (!brandsFilter) {
    return searchParams.filters.brandCodes
  }

  return (brandsFilter.options as CheckboxFilterOption[])
    ?.filter((x) => x.selected)
    .map((x) => x.code)
}

export const updateSearchFilters = (
  searchParams: SearchControllerParams,
  items: FilterCategory[]
): AvailabilitySearchFilters => {
  return {
    ...searchParams.filters,
    tags: convertToFilterTags(
      items.filter((x) => x.type === "checkbox" && !["brand"].includes(x.key))
    ),
    ...getPriceFilters(items),
    ...getDiscountFilters(items),
    brandCodes: getBrandFilters(searchParams, items),
  }
}

export const updateCheckboxOption = (
  uiFilters: FilterCategory[],
  option: CheckboxFilterOption
) => {
  const newFilters = jsonClone(uiFilters) as FilterCategory[]

  newFilters.forEach((x) => {
    const filter = expandTreeOptions(x.options as CheckboxFilterOption[]).find(
      (x) => x.value === option.value
    )
    if (filter) {
      filter.selected = option.selected
    }
  })

  return newFilters
}

export const calculateNewFilters = (
  currentFilters: FilterCategory[],
  option: CheckboxFilterOption
) => {
  let newFilters = updateCheckboxOption(currentFilters, option)
  if (option.selected === false && option.children) {
    for (const child of option.children) {
      newFilters = updateCheckboxOption(newFilters, {
        ...child,
        selected: false,
      })
    }
  }
  if (option.selected === false && option.parent) {
    const category = newFilters.find((x) => x.key === option.key)
    const allOptions = expandTreeOptions(
      (category?.options ?? []) as CheckboxFilterOption[]
    )
    const parentItem = allOptions.find((x) => x.value === option.parent?.value)
    if (!parentItem) {
      console.error(`Parent item not found ${option.parent?.value}`)
      return newFilters
    }
    newFilters = updateCheckboxOption(newFilters, {
      ...parentItem,
      selected: false,
    })
  }
  return newFilters
}
